// Shared layout classes for the chat confirmation cards (#517).
//
// PO (split view / narrow chat): the Confirm · Decline · Edit row overflowed —
// Edit stuck out past the card's right edge — and the result box ("✓ Contact
// **Laura Méndez** created.") squeezed the name into a middle column. Two causes:
//   * the action rows were `flex items-center` WITHOUT wrap, and each button's
//     label was a bare text node, so the row's min-content width was the sum of
//     every label + padding;
//   * the summary box was `flex items-center` with the sentence passed as a
//     FRAGMENT — every text node / <span> of it became its own flex item (a
//     column), so the bold name wrapped inside its own middle column.
// Fix: rows wrap, buttons never exceed the card (label truncates, icon never
// shrinks), and a summary's sentence is ONE inline flow in a min-w-0 span. In a
// narrow card (`useCompactWidth`) the Edit button shows only its icon.

/** A card's button row: wraps onto a second line instead of overflowing. */
export const CARD_ACTION_ROW = 'mt-3 flex flex-wrap items-center gap-2 min-w-0';

/** Added to every card button: never wider than the card. */
export const CARD_BTN_FIT = 'max-w-full min-w-0';

/** A button label span: truncates instead of forcing the row wider. */
export const CARD_BTN_LABEL = 'min-w-0 truncate';

/** A button / summary icon: never squeezed. */
export const CARD_ICON = 'shrink-0';

/** The sentence inside a done / cancelled summary: one flow that wraps naturally. */
export const CARD_SUMMARY_TEXT = 'min-w-0 flex-1 break-words';

/** Card width (px) under which the Edit button collapses to its icon. */
export const CARD_COMPACT_WIDTH = 340;
